import {BaseClient, DataType} from "./BaseClient"
import {Result} from "./Result"

export type P415FileType = 'DeliveryData' | 'BaseCons' | 'OptCons'

export interface P415FileApi {
    simpleFilename: string
    fileName: string
    dateTime: string
    fileType: string
    mpan: string
}

export class P415Client {
    private baseClient: BaseClient

    constructor(baseClient: BaseClient) {
        this.baseClient = baseClient
    }

    async uploadFile(mpan: string, fileType: P415FileType, file: File): Promise<Result<null>> {
        const url = `/api/edf/fileUpload?mpan=${mpan}&fileType=${fileType}`
        return this.baseClient.postOk(url, file, DataType.FORM_DATA)
    }

    async listFiles(selectedBuilding: { id: number } | undefined): Promise<Result<P415FileApi[]>> {
        const queryParams = new URLSearchParams({maxNumber: '10000'})
        if (selectedBuilding) queryParams.append('buildingId', selectedBuilding.id.toString())
        const url = '/api/edf/listOfUploadedFiles?' + queryParams.toString()
        return this.baseClient.getOkP<P415FileApi[]>(url)
    }

    async retrieveFile(file: P415FileApi): Promise<Result<Blob>> {
        const url = `/api/edf/uploadedFiles/${file.fileName}`
        return this.baseClient.getOkBlob(url)
    }

    async retrieveFiles(selectedBuilding: { id: number } | undefined): Promise<Result<Blob>> {
        const url = selectedBuilding ? `/api/edf/uploadedFiles?buildingId=${selectedBuilding.id}` : '/api/edf/uploadedFiles'
        return this.baseClient.getOkBlob(url)
    }
}
